<template>
  <div class="w-100">
    <b-form-select
        :options="members"
        v-if="!isLoadingMember"
        v-on="$listeners"
        v-model="selectedMember"
        :state="state"
    ></b-form-select>
    <b-skeleton v-if="isLoadingMember" type="input" width="100%"></b-skeleton>
    <b-form-invalid-feedback v-if="errorMessage">
      {{ errorMessage }}
    </b-form-invalid-feedback>
  </div>
</template>

<script>
import {lookupMember} from "@/services/members";

export default {
  name: "MemberDropDown",
  props:{
    member: {
      type: Object,
    },
    errorMessage: {
      type: String,
    },
    state:null,
    showSuperAdmin: {
      type: Boolean,
      default: false,
    },
    showAllMembers: {
      type: Boolean,
      default: false,
    },
  },
  data:()=>({
    isLoadingMember: false,
    members: [
      { value: null, text: 'Super Administrator'},
    ],
    selectedMember: null,
  }),
  methods:{
    async loadMembers() {
      try {
        this.isLoadingMember = true;
        const {data: {data: {rows}}} = await lookupMember();
        const members = Array.isArray(rows.member) ? rows.member : [rows.member];
        this.members = (members.map(({id, company_name}) => ({value: {id, company_name}, text: company_name})));
        if (this.showSuperAdmin) {
          this.members.unshift(
              { value: null, text: 'Super Administrator'}
          )
        }
        if (this.showAllMembers) {
          this.members.unshift(
              { value: '', text: 'All Members'}
          )
        }
        this.$emit('update:members', this.members)
      } catch (e) {
        this.members = [
          { value: null, text: 'Super Administrator'},
        ];
      }
      this.isLoadingMember = false;
    }
  },
  async mounted() {
    await this.loadMembers();
    if (this.member) {
      this.selectedMember = this.member
    }
  },
}
</script>

<style scoped>

</style>
